<form [formGroup]="form">
  <mat-form-field appearance="outline">
    @if (!hideLabel) {
      <mat-label>
        @if (!autoTranslate) {
          <span>{{labelName}}</span>
        }
        @if (autoTranslate) {
          <mwp-text-translate [text]="labelName" [jsonKey]="labelName" />
        }
      </mat-label>
    }
    @if (!maskType && !autoComplete) {
      <input matInput [id]="nameForControl" [type]="inputType" [formControlName]="nameForControl" [maxlength]="maxLength" (keyup)="onKeyUp($event)" (paste)="onPaste($event)">
    }
    @if (maskType && !autoComplete) {
      <input matInput [id]="nameForControl" [type]="inputType" [formControlName]="nameForControl" [mwpMask]="maskType" [mwpMaskForm]="form" [mwpMaskFormControlName]="nameForControl" [maxlength]="maxLength" (keyup)="onKeyUp($event)" (paste)="onPaste($event)">
    }
    @if (!maskType && autoComplete) {
      <input matInput [id]="nameForControl" [type]="inputType" [formControlName]="nameForControl" [maxlength]="maxLength" (keyup)="onKeyUp($event)" (paste)="onPaste($event)" [attr.autocomplete]="autoComplete">
    }
    @if (maskType && autoComplete) {
      <input matInput [id]="nameForControl" [type]="inputType" [formControlName]="nameForControl" [mwpMask]="maskType" [mwpMaskForm]="form" [mwpMaskFormControlName]="nameForControl" [maxlength]="maxLength" (keyup)="onKeyUp($event)" (paste)="onPaste($event)" [attr.autocomplete]="autoComplete">
    }
  </mat-form-field>
</form>